module.exports = __webpack_public_path__ + "fonts/5fdc935e-9e30-442a-bbe9-8d887b858471.e20dca98.woff";